let DOMAIN = 'admqr.special-rt.com'
let PROJECT_PATH = 'admqr.special-rt.com';
if (window.location.hostname.indexOf('admqr.special-rt.com') + 1 > 0) {
    DOMAIN = `admqr.special-rt.com`;
    PROJECT_PATH = `https://admqr.special-rt.com`;
}


if (window.location.hostname.indexOf('adm-qr.kanzlerdaddy.ru') + 1 > 0) {
    DOMAIN = `adm-qr.kanzlerdaddy.ru`;
    PROJECT_PATH = `https://adm-qr.kanzlerdaddy.ru`;
}

const CONFIG = {
    API: window.location.hostname.indexOf('localhost') + 1 > 0 ? 'http://127.0.0.1:9000/api/backend' : '/api/backend',
    STATIC_FILES: window.location.hostname.indexOf('localhost') + 1 > 0 ? 'http://127.0.0.1:9000/qr' : '/share',
    OAUTH_API: `https://auth.b37m.ru/auth`,
    OAUTH: `https://auth.b37m.ru/`,
    OAUTH_DOMAIN: DOMAIN,
    PROJECT_PATH: PROJECT_PATH,
    AUTH_PREFIX: '',
    AUTH_HEADER: 'X-Access-Token',
    MENU: [
        {
            title: 'Dashboard',
            path: "/",
            icon: "appstore"
        },
        {
            title: "Qr code",
            path: "/qr",
            icon: "qrcode"
        }
    ],
    ERRORS: {
        'TOKEN_EXPIRED' : 'User tokens is expired',
    },
    QR_NAMES: [
        'NIZAL',
        'ART',
        'PPP',
        'PANORAMA',
        'ONE WORD',
        'DIBATE',
        'DITALES',
        'NEWSMAKER',
        'RT INVESTIGATIONS'
    ],
};

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config.js